import { useNavigate, useParams } from 'react-router-dom';

import useAppointmentStore from '@/store/AppointmentStore';
import AgentSelectionLayout from './AgentSelectionLayout';

const SelectAgent: React.FC = () => {
  const navigate = useNavigate();
  const selectedAgent = useAppointmentStore((state) => state.selectedAgent);
  const { id } = useParams();

  const handleClickContinue = () => {
    if (!selectedAgent?.agentRecordId) {
      return;
    }

    navigate(`/schedule-appointment/${id}/contact-info`);
  };

  return <AgentSelectionLayout onClickContinue={handleClickContinue} />;
};

export default SelectAgent;
